import { render, staticRenderFns } from "./EditAdviseInfo.vue?vue&type=template&id=201004fc&scoped=true&"
import script from "./EditAdviseInfo.vue?vue&type=script&lang=js&"
export * from "./EditAdviseInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditAdviseInfo.vue?vue&type=style&index=0&id=201004fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201004fc",
  null
  
)

export default component.exports